<template>
    <div class="slideInUp">
        <div class="contentBox1_info_img">
            <img :src="baseUrl+'img/'+url+'.png'" height="100%" alt="" srcset="">
        </div>
        <div class="contentBox1_info_text">{{cloNum}}<span>{{postfix}}</span></div>   
        <div class="contentBox1_info_text_mini">{{textMini}}</div>                 
    </div>
</template>
<script>
export default {
    name:"slideInUp",
    data() {
        return {
            numbers:0,
            timer:null,
            baseUrl:process.env.BASE_URL, 
        }
    },
    computed:{
        cloNum(){
            if(this.numbers>=1000){
                return parseInt(this.numbers/1000)+',' + (this.numbers%1000>0?this.numbers%1000:'000')
            }else{
                return this.numbers
            }
        }
    },
    props:[
        'textMini','type','number','postfix','url'
    ],
    mounted(){
        this.timer = setInterval(()=>{
            if(this.type=='clothes'){
                this.numbers+=250
            }else if(this.type=='country'){
                this.numbers+=1
            }else if(this.type=='product'){
                this.numbers+=1
            }
            if(this.numbers==this.number){
                clearInterval(this.timer)
            }
        },50)
    }
}
</script>
<style lang="less">
.slideInUp{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 30vh;
    margin-top: 2rem;
    .contentBox1_info_text_mini{
        // background-color: red;
        color: rgb(138, 138, 138);
        font-size: 0.75rem;
        height: 1rem;
        text-align: center;      
        letter-spacing: 0.1rem;
    }
    .contentBox1_info_img{
        height: 150px;
    }
    .contentBox1_info_text{
    // background-color: red;
        margin-top: 2.5rem;
        font-size: 3rem;
        color: #017CA4;
        // font-family: 'regular';
        // font-family: ;
        // font-family: "微软雅黑";
        // font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        span{
            font-size: 1.3rem;
            color: #6B6B6B;            
            margin-left: 0.5rem;
        }
    }
}

</style>

